import React, {useContext, useState} from "react";
import {Alert, Spin, Tabs} from "antd";
import useRMateChart from "./useRMateChart";
import MapPropsContext from "../MapPropsContext";
import useDebounce from "../../../utils/hooks/useDebounce";
import {getApiHost} from "../../../utils";
import Axios from "axios";
import ChartPane from "./ChartPane";
import {layoutForChart1, layoutForChart2} from "./RMateChartSpecificAmaUtils";


const RMateChartSpecificAma = ({disabled}) => {
  const {
    chartAjaxParams,
  } = useContext(MapPropsContext);

  const {
    sidoCode,
    searchYear,
    chkString01,
    prm_check, prm_check_label,
  } = chartAjaxParams;

  const [isInit, setIsInit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [prevParams, setPrevParams] = useState();
  const [parsedObject, setParsedObject] = useState({});


  useDebounce(() => {
      if (isInit) {
        const url = getApiHost() + '/rwdinfolabstats/getSpcifyRdwStats3.json';

        const newParams = {
          sidoCode,
          searchYear,
          chkString01,
        };

        if (!disabled && (JSON.stringify(prevParams) !== JSON.stringify(newParams))) {
          setPrevParams(newParams);
          setIsLoading(true);
          setParsedObject({}); // 초기화

          Axios.get(url, {params: newParams})
            .then(({data}) => {

              const chart1List = data['itemArea'];
              const chart1ListData2 = chart1List.sort(function(a, b) {
                return a.DATA_SUM_CNT - b.DATA_SUM_CNT;
              });
              const chart2List = data['item'];
              // chart1에 대해서는 reverse된 데이터를 쓰고 있음.
              setParsedObject({
                chart1List, chart1ListData2, chart2List
              });

            })
            .catch(e => console.error(e))
            .finally(() => {
              setIsLoading(false);
            });
        }
      }
    },
    1000,
    [isInit, prevParams, chartAjaxParams, setIsLoading]);

  const {
    chart1ListData2, chart2List
  } = parsedObject;

  return useRMateChart({
    init: () => setIsInit(true),
    style: {minHeight: '540px'},
    disabled,
    children: (
      <div>
        {/*{isLoading && <Spin style={{position: 'absolute', left: '50%', top: '50%', zIndex: 1}} size={"large"}/>}*/}
         {isLoading &&
          <div style={{position: 'absolute', top: 55, zIndex: 1, height: '90%', width: '100%', backgroundColor: 'white'}}>
            <Spin size={"large"}>
              <Alert
                message="차트 로딩 중"
                description="선택한 무선국의 정보를 불러오는 중입니다.."
                type="info"
                showIcon
                style={{height: '470px'}}
              />
            </Spin>
          </div>
        }
        <Tabs type={"card"} defaultActiveKey={"chart1"}>
          <Tabs.TabPane key={"chart1"} tab={`지역별 아마추어무선국 수 - ${getLabelForYearMonth(searchYear)}`}>
            <ChartPane data={chart1ListData2}
                       processor={() => chart1ListData2}
                       layoutProcessor={() => layoutForChart1(CHART1_LAYOUT_PROPS, {
                         searchYear,
                         prm_check: prm_check,
                         prm_check_label: prm_check_label,
                       })}
                       style={chart1ListData2 && chart1ListData2.length > 18
                           ? {height: chart1ListData2.length * 30}
                           : {height: 470}}/>
          </Tabs.TabPane>
          <Tabs.TabPane key={"chart2"} tab={`년도별 아마추어무선국 수 - ${getLabelForYearMonth(searchYear)}`}>
            <ChartPane data={chart2List}
                       processor={() => chart2List}
                       layoutProcessor={() => layoutForChart2(CHART2_LAYOUT_PROPS,
                         chart2List,{
                         searchYear,
                         prm_check: prm_check,
                         prm_check_label: prm_check_label,
                       })}
                       style={chart2List && chart2List.length > 18
                           ? {height: chart2List.length * 30}
                           : {height: 470}}/>
          </Tabs.TabPane>
        </Tabs>
      </div>
    ),
  })
};

const getLabelForYearMonth = (yearMonth) => {
  if (yearMonth) {
    if (yearMonth.length === 4) {
      return `${yearMonth}년`;
    } else if (yearMonth.length === 6) {
      return `${parseInt(yearMonth.substr(0, 4))}년`;
    }
  }
  return yearMonth;
};

const CHART1_LAYOUT_PROPS = {
  title: "지역별 아마추어무선국 수",
  xtitle: "무선국 수",
  ytitle: "지역명",
  chartType: "Multi Series Stacked Bar",
  layOutStyle: "Detail",
  masterName: "무선국 수",
  valueFixed: 0,
};

const CHART2_LAYOUT_PROPS = {
  title: "년도별 아마추어무선국 수",
  xtitle: "년도",
  ytitle: "무선국 수",
  chartType: "Multi Series Stacked",
  layOutStyle: "Master",
  masterName: "2",
  valueFixed: 0,
};


export default RMateChartSpecificAma;
